import { type ReactNode } from "react";
import { Modal } from "./Modal";
import { Button } from "./Button";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: ReactNode;
  body?: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  destructive?: boolean;
  loading?: boolean;
  icon?: ReactNode;
}

/**
 * Generic confirmation modal with primary + secondary actions. Used for
 * destructive or irreversible operations.
 */
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  description,
  body,
  confirmLabel,
  cancelLabel = "Cancel",
  destructive,
  loading,
  icon,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onClose} maxWidth={420}>
      {icon ? (
        <div className="text-center text-[36px] leading-none">{icon}</div>
      ) : null}
      <h3 className="text-center text-[18px] font-bold tracking-tight text-[#1a1a1a]">
        {title}
      </h3>
      {description ? (
        <p className="mt-2 text-center text-[13px] text-[#6c757d]">{description}</p>
      ) : null}
      {body ? <div className="mt-4">{body}</div> : null}
      <div className="mt-5 flex flex-col gap-2">
        <Button
          variant={destructive ? "destructive" : "primary"}
          onClick={onConfirm}
          loading={loading}
          fullWidth
        >
          {confirmLabel}
        </Button>
        <Button variant="secondary" onClick={onClose} fullWidth>
          {cancelLabel}
        </Button>
      </div>
    </Modal>
  );
}
